import { ProjectDetailState } from '../state';
import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { Product } from '../../../../data/terra/Product';
import { ResourceState } from '../../common/Resource';

const UPDATE_PROJECT = 'project/update';

export interface UpdateProjectAction {
  type: typeof UPDATE_PROJECT;
  project: Product;
}

export const updateProject =
  (project?: Product): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch({
      type: UPDATE_PROJECT,
      project,
    } as UpdateProjectAction);
  };

export const updateProjectDelegate: DelegateMapEntry<
  UpdateProjectAction,
  ProjectDetailState
> = {
  [UPDATE_PROJECT]: (
    state: ProjectDetailState,
    action: UpdateProjectAction
  ): ProjectDetailState => {
    return {
      ...state,
      project: {
        state: ResourceState.Success,
        data: action.project,
        error: undefined,
      },
    };
  },
};
